export default __webpack_public_path__ + "static/media/ThePiano_04.631223cc.png";